// extracted by mini-css-extract-plugin
export default {"skeleton-rectangle":"c0c8fd","pulse":"adc813"};